export default "__VITE_ASSET__2jqu1mg2__"